import BaseService from '../base.service';

export class TopUpService {
  // 查询充值方式(下拉列表)
  static async topUpAllListApi() {
    return BaseService.get('/web/topUp/list');
  }

  // 搜索充值记录(已完成的账单流水)
  static async topUpPageListApi(queryOptions) {
    return BaseService.get('/web/topUp', queryOptions);
  }

  // 查询"待处理"的充值请求(status=1,含收款人/收款账号)
  static async pendingListApi() {
    return BaseService.get('/web/topUp/pending');
  }
}
